"use strict";

(function () {
  if (customElements.get("product-reviews-showcase")) return;

  class ProductReviewsShowcase extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.currentIndex = 0;
      this.total = 0;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll("[data-review-slide]"));
      this.total = this.slides.length;
      this.countEl = this.querySelector("[data-review-count]");
      this.prevBtn = this.querySelector("[data-review-prev]");
      this.nextBtn = this.querySelector("[data-review-next]");

      const reviewsLink = this.querySelector("[data-reviews-section-id]");
      if (reviewsLink && reviewsLink.dataset.reviewsLinkBound !== "true") {
        reviewsLink.dataset.reviewsLinkBound = "true";
        reviewsLink.addEventListener("click", (e) => {
          e.preventDefault();
          openReviewsAccordion(reviewsLink.getAttribute("data-reviews-section-id"));
        });
      }

      if (this.total < 2) return;

      this.prevBtn?.addEventListener("click", () => this.goTo(this.currentIndex - 1));
      this.nextBtn?.addEventListener("click", () => this.goTo(this.currentIndex + 1));

      this.slides.forEach((slide, index) => {
        this.positionSlide(slide, index);
      });
    }

    goTo(index) {
      const newIndex = ((index % this.total) + this.total) % this.total;
      if (newIndex === this.currentIndex) return;
      this.currentIndex = newIndex;
      this.update();
    }

    positionSlide(slide, index) {
      slide.classList.remove("active", "before");
      if (index === this.currentIndex) {
        slide.classList.add("active");
      } else if (index < this.currentIndex) {
        slide.classList.add("before");
      }
    }

    update() {
      this.slides.forEach((slide, index) => {
        this.positionSlide(slide, index);
      });

      if (this.countEl) {
        this.countEl.textContent = `${this.currentIndex + 1}/${this.total}`;
      }
    }
  }

  customElements.define("product-reviews-showcase", ProductReviewsShowcase);

  function openReviewsAccordion(selector) {
    const accordion = document.querySelector(
      selector || "#product__accordion__reviews"
    );
    if (!accordion) return;

    const details =
      accordion.querySelector(".product__accordion__reviews__toggle") ||
      accordion.querySelector("details");
    if (!details) return;

    if (!details.open) {
      const summary = details.querySelector("summary");
      if (summary) {
        summary.click();
      } else {
        details.open = true;
      }
    }

    accordion.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  window.openReviewsAccordion = openReviewsAccordion;
})();
